'use strict';

module.exports = [// type
require('./Complex'), // construction function
require('./function/complex')];